import React from "react";
import { Row, Col } from "react-bootstrap";
import "./BirthdayUser.css";

function BirthdayUser({
  id,
  firstName,
  lastName,
  profileName,
  profileNameEnglish,
  language,
  day,
}) {
  return (
    <Col className="birthday-user">
      <Row className="justify-content-center align-items-center">
        <Col lg={1} className="center">
          <h4>{day}</h4>
        </Col>
        <Col lg={11}>
          <h6>{firstName + " " + lastName}</h6>
          <p>{language === "es" ? profileName : profileNameEnglish}</p>
        </Col>
      </Row>
    </Col>
  );
}

export default BirthdayUser;
